import "./CountrySelect.scss";

import React from "react";
import clsx from "clsx";
import AsyncState from "react-async-stateful";

import * as ReactUtils from "../../../lib/util/ReactUtils";

import Select from "../Select/Select";
import Asset from "../../common/Asset/Asset";
import Text from "../../common/Text/Text";

let countryData = null;
let countryOptions = [];

export default class CountrySelect extends React.PureComponent {
	state = {
		countryData: AsyncState.create(null),
	};

	componentDidMount() {
		ReactUtils.old__setStateAsync(this, {
			countryData: this.retrieveCountryData(),
		});
	}

	async retrieveCountryData() {
		if (countryData) return countryData;
		const countryList = await import("country-list");
		countryData = countryList.getData();
		countryOptions = countryData.map((country) => ({
			value: country.code,
			label: `${country.name} (${country.code})`,
		}));
		return countryData;
	}

	render() {
		const { className, ...props } = this.props;
		const { countryData } = this.state;

		return (
			<Select
				loading={countryData.pending}
				options={countryOptions}
				onRenderOption={(option) => (
					<>
						<Asset
							className={"CountrySelect__flag"}
							src={`https://www.countryflags.io/${option.value}/flat/24.png`}
							alt={`${option.label} Flag`}
						/>{" "}
						<Text inline={true}>{option.label}</Text>
					</>
				)}
				className={clsx("CountrySelect", className)}
				{...props}
			/>
		);
	}
}
